import { ReactElement } from 'react';
import { EMAIL_PATTERN } from '@client/common/utils/validations/validationRules';
import { useTranslate } from '@client/i18n/hooks';
import { Formik } from 'formik';
import * as yup from 'yup';
import { REPORT_PRODUCT_ERROR_SUBJECT_TYPE } from 'b2b-common/shop/product/api/Product.types';
import { Body } from './Body';
import { Props } from './Form.types';
import { FIELD_NAME } from './FormContainer.types';

export const Form = ({
  isSubmitting,
  hasSubmissionFail,
  onSubmit,
  onFormHide,
}: Props): ReactElement => {
  const t = useTranslate();

  const initialValues = {
    [FIELD_NAME.subject]: REPORT_PRODUCT_ERROR_SUBJECT_TYPE.productDescription,
    [FIELD_NAME.email]: '',
    [FIELD_NAME.text]: '',
  };

  const validationSchema = (): Record<string, any> => {
    const schema: Record<string, any> = {
      [FIELD_NAME.subject]: yup.string().required(t('Required')),
      [FIELD_NAME.text]: yup.string().required(t('Required')),
      [FIELD_NAME.email]: yup.string().matches(EMAIL_PATTERN, t('Email is not valid')),
    };

    return yup.object().shape(schema);
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      <Body
        onCancel={onFormHide}
        isSubmitting={isSubmitting}
        hasSubmissionFail={hasSubmissionFail}
      />
    </Formik>
  );
};
